var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _path5, _rect9, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H58L72 20V74H20V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 4H18V76H74V20L58 4ZM58 7L71 20H58V7ZM20 74H72V22H56V6H20V74Z",
    fill: "#A6A6A6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 64,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 58,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 46,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 26,
    height: 2,
    fill: "#C8C8C8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 12,
    width: 14,
    height: 2,
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26L40 22V68L6 64V26Z",
    fill: "#2C5898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37L30.5 54H26.25L23.43 43.09C23.2724 42.4647 23.1819 41.8244 23.16 41.18C23.1101 41.8242 23.0064 42.4631 22.85 43.09L19.9 54H15.47L11 37H15.19L17.59 48.32C17.7134 48.9603 17.7903 49.6086 17.82 50.26H17.89C17.9309 49.583 18.0448 48.9124 18.23 48.26L21.31 37H25.42L28.21 48.42C28.3402 49.0234 28.4304 49.6347 28.48 50.25C28.5135 49.6111 28.5971 48.9758 28.73 48.35L31.13 37H35Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 4H18V24.59L6 26V64L18 65.41V76H74V20L58 4Z",
    fill: "url(#paint0_linear)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 22,
    width: 16,
    height: 6,
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 4H18V6H56V22H72V50H74V20L58 4Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 74H18V65.42L40 68V74Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68L6 64V26L40 22V68Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -20.7706,
    y1: 39.8882,
    x2: 41.5836,
    y2: 106.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5E5E5E",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 71.5067,
    y1: 27.81,
    x2: 71.5067,
    y2: 22.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#303030",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 59.5939,
    y1: 23.4779,
    x2: 67.2657,
    y2: 12.1079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 37.701,
    y1: 74.0263,
    x2: 37.8153,
    y2: 66.8861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 38.2076,
    y1: 65.58,
    x2: 38.2076,
    y2: 24.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.93259b41753de939d131d49358e8004a.svg";
export { ForwardRef as ReactComponent };